var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"查看兑换详情","width":"716px","destroyOnClose":true,"bodyStyle":{ padding: 0 },"footer":false},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('main-table',{ref:"table"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }